import { render, staticRenderFns } from "./system_menu.vue?vue&type=template&id=0059663a&scoped=true"
import script from "./system_menu.vue?vue&type=script&lang=js"
export * from "./system_menu.vue?vue&type=script&lang=js"
import style0 from "./system_menu.vue?vue&type=style&index=0&id=0059663a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0059663a",
  null
  
)

export default component.exports